import {
    Flex,
    Grid,
    useAppDisplayModeContext,
    useStyles,
    useImageConfig,
} from '@archipro-design/aria';
import * as S from '@modules/project/component/about-professional/Associations.style';
import { Link } from '@remix-run/react';

interface ProfessionalAssociation {
    ID: number;
    Title: string;
    Link: string;
    CompanyLogo?: string | null;
    LogoBackgroundColor?: string | null;
}

interface StatsProps {
    data: {
        node: ProfessionalAssociation;
    }[];
}

const Associations = ({ data }: StatsProps) => {
    const { css } = useStyles();
    const { mobile } = useAppDisplayModeContext();
    const { loader: imageLoader } = useImageConfig();

    return (
        <Flex data-testid="associations" className={css(S.Associations)}>
            <Grid columns={mobile ? 3 : 6}>
                {data.map(({ node }) => {
                    const companyLogo =
                        node.CompanyLogo && imageLoader
                            ? imageLoader({
                                  src: node.CompanyLogo,
                                  width: 40,
                              })
                            : '';
                    const bgColor = node.LogoBackgroundColor ?? undefined;
                    return (
                        // eslint-disable-next-line jsx-a11y/anchor-has-content
                        <Link
                            key={`assoc-${node.ID}`}
                            to={node.Link}
                            title={node.Title}
                            className={css(S.Association)}
                            style={{
                                backgroundColor: bgColor ?? 'transparent',
                                backgroundImage: `url(${companyLogo})`,
                                backgroundBlendMode: bgColor
                                    ? 'unset'
                                    : 'multiply',
                            }}
                            prefetch="intent"
                        />
                    );
                })}
            </Grid>
        </Flex>
    );
};

export default Associations;
